export const COMPONENTS = {
  // FULL_CARD: "full-card",
  SITE_SEARCH: "Strapi_ComponentSearchesSiteSearch",
  // BANNER_SEARCH: "banner-search",
  HTML: "Strapi_ComponentBasicHtml",
  MARKDOWN: "Strapi_ComponentBasicText",
  MEDIA: "Strapi_ComponentBasicMedia",
  SUBNAV_LINK: "Strapi_ComponentLinksSubnavLink",
  SUBNAV_LINK_WITH_CHILDREN: "Strapi_ComponentLinksSubnavLinkWithChildren",
  ICON: "Strapi_ComponentIconsIcon",
  ICON_ROW: "Strapi_ComponentIconsIconRow",
  LINK: "Strapi_ComponentLinksLink",
  LINK_LIST: "Strapi_ComponentLinksLinkList",
  CAROUSEL: "Strapi_ComponentRowsCarousel",
  TESTIMONIAL_CAROUSEL: "Strapi_ComponentRowsTestimonialCarousel",
  HERO: "Strapi_ComponentHeroesHero",
  HERO_VIDEO_BG: "Strapi_ComponentHeroesHeroVideoBg",
  HERO_SIDE_BY_SIDE: "Strapi_ComponentHeroesHeroSideBySide",
  PEEKABOO_ROW: "Strapi_ComponentRowsPeekabooRow",
  COLUMN_1: "Strapi_ComponentColumnSections1Column",
  COLUMN_1_SLIDESHOW: "Strapi_ComponentColumnSections1ColumnSlideshow",
  COLUMN_2: "Strapi_ComponentColumnSections2Column",
  COLUMN_3: "Strapi_ComponentColumnSections3Column",
  COLUMN_4: "Strapi_ComponentColumnSections4Column",
  TOC_2_COLUMN: "Strapi_ComponentColumnSectionsToc2Column",
  INSERT_SNIPPET: "Strapi_ComponentSnippetInsertSnippet",
  CUSTOM_DATA: "Strapi_ComponentBasicCustomData",
  SNIPPET_MARKDOWN: "Strapi_ComponentSnippetSnippetText",
  SNIPPET_MEDIA: "Strapi_ComponentSnippetSnippetMedia",
  SNIPPET_LINK: "Strapi_ComponentSnippetSnippetLink",
  FEATURED_POST: "Strapi_ComponentRowsFeaturedPost",
  FEATURED_POSTS_ROW: "Strapi_ComponentRowsFeaturedPostsRow"
};

export const DOMAIN = "/polebase";
export const POLEBASE_SITE_ID = "polebase-2";
